export const TODAY = 0;
export const THIS_MONTH = 1;
export const THIS_YEAR = 2;